const LOGO_IMAGES = [
  "/logos/logo-1.png",
  "/logos/logo-2.png",
  "/logos/logo-3.png",
  "/logos/logo-4.png",
  "/logos/logo-5.png",
  "/logos/logo-6.png",
  "/logos/logo-7.png",
  "/logos/logo-8.png",
  "/logos/logo-9.png",
  "/logos/logo-11.png",
  "/logos/logo-11-1.png",
  "/logos/logo-12.png",
  "/logos/logo-12-1.png",
  "/logos/logo-13.png",
  "/logos/logo-13-1.png",
  "/logos/logo-14.png",
  "/logos/logo-14-1.png",
  "/logos/logo-15.png",
  "/logos/logo-15-1.png",
  "/logos/logo-16.png",
  "/logos/logo-17-1.png",
  "/logos/logo-18.png",
  "/logos/logo-19.png",
  "/logos/logo-20.png",
  "/logos/logo-21.png",
  "/logos/logo-22.png",
  "/logos/logo-23.png",
  "/logos/logo-24.png",
  "/logos/logo-25.png",
  "/logos/logo-26.png",
  "/logos/logo-27.png",
  "/logos/logo-29.png",
  "/logos/logo-31.png",
  "/logos/logo-33.png",
  "/logos/logo-34.png",
  "/logos/logo-35.png",
  "/logos/logo-36.png",
  "/logos/logo-37.png",
  "/logos/logo-38.png",
  "/logos/logo-39.png",
  "/logos/logo-40.png",
  "/logos/logo-41.png",
  "/logos/logo.jpg",
];

// Split into 2 rows for double-strip marquee animation
const halfIndex = Math.ceil(LOGO_IMAGES.length / 2);
const row1Source = LOGO_IMAGES.slice(0, halfIndex);
const row2Source = LOGO_IMAGES.slice(halfIndex);

// Duplicate once so -50% translateX creates a 100% seamless infinite loop
const row1 = [...row1Source, ...row1Source];
const row2 = [...row2Source, ...row2Source];

/**
 * LogoMarquee - Two-row infinite image logo marquee.
 * Row 1 scrolls left, Row 2 scrolls right (reverse).
 * Uses real company logo image assets from /public/logos.
 */
export const LogoMarquee = () => {
  return (
    <section className="border-b border-border bg-white py-12 overflow-hidden">
      <p className="mb-8 text-center text-xs font-semibold uppercase tracking-[0.25em] text-muted-foreground">
        Trusted by Professionals From
      </p>

      {/* Row 1 - scrolls left */}
      <div className="relative mb-6">
        {/* Left & Right gradient fade masks */}
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-28 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-28 bg-gradient-to-l from-white to-transparent" />

        <div className="flex w-max animate-marquee items-center gap-6">
          {row1.map((src, i) => (
            <div
              key={i}
              className="flex h-20 w-48 shrink-0 items-center justify-center rounded-2xl bg-[#F6F6F6] px-5 py-3 transition-transform duration-300 hover:scale-105 cursor-default"
            >
              <img
                src={src}
                alt={`Company logo ${i + 1}`}
                className="max-w-full object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Row 2 - scrolls right (reverse) */}
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-28 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-28 bg-gradient-to-l from-white to-transparent" />

        <div className="flex w-max animate-marquee-reverse items-center gap-6">
          {row2.map((src, i) => (
            <div
              key={i}
              className="flex h-20 w-48 shrink-0 items-center justify-center rounded-2xl bg-[#F6F6F6] px-5 py-3 transition-transform duration-300 hover:scale-105 cursor-default"
            >
              <img
                src={src}
                alt={`Company logo ${i + 1}`}
                className="max-w-full object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
